import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { mistakes } from '../data/lessons';
import './Mistakes.css';

export default function Mistakes() {
  return (
    <div className="mistakes-page">
      <Helmet>
        <title>Common Mistakes — DhanAcademy</title>
        <meta name="description" content="The traps Indian investors fall into. Learn to recognize and avoid the most common financial mistakes." />
      </Helmet>

      <section className="mistakes-hero">
        <div className="mistakes-hero-inner">
          <span className="mistakes-pill">MISTAKES &amp; TRAPS</span>
          <h1 className="mistakes-hero-title">The traps Indian investors fall into.</h1>
          <p className="mistakes-hero-sub">
            Most financial losses don't come from bad luck — they come from well-known traps. Learn to spot them before they cost you.
          </p>
        </div>
      </section>

      <div className="mistakes-body">
        <div className="mistakes-inner">
          <div className="mistakes-count">{mistakes.length} common mistakes</div>
          <div className="mistakes-grid">
            {mistakes.map(m => (
              <Link key={m.id} to={`/mistakes/${m.id}`} className="mistakes-card">
                <div className="mistakes-card-icon">!</div>
                <h3 className="mistakes-card-title">{m.title}</h3>
                <p className="mistakes-card-desc">{m.description}</p>
                {m.warning && (
                  <div className="mistakes-card-warning">{m.warning}</div>
                )}
                <span className="mistakes-card-link">Read full article →</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
